import { GranteeState } from './grantee.state';
import { AccessTypeSelection } from '../../../common/enums/access-type-selection.enum';
import { ClientTypes } from '../../../common/enums/client-types.enum';

export const granteeInitialState: GranteeState = {
    accessType: AccessTypeSelection.LIMITED_ACCESS,
    clientType: ClientTypes.UNKNOWN,
    granteeIneligibleReason: null,
    isLoading: false,
    error: null,
    granteeRegulatoryQuestions: null,
    hasFullRegError: false,
    bulkAcceptResponse: null,
    isMultiAccount: false,
};
